<template>
  <v-container grid-list-md justify-center>
    <!--  -->
    <v-row wrap justify="space-between" align="content-space-around" style="margin-top: 55px">
      <v-flex md8 sm10 xs12>
        <!--  -->
        <v-card class="elevation-10 ma-3" style="border-radius: 3px;">
          <v-card-text>
            <v-card
              style="margin-top: -50px;padding: 15px;border-radius: 10px;"
              dark
              height="100"
              class="elevation-20"
            >
              <v-card-title>
                <v-row justify="space-between">
                  <div class="d-flex flex-column">
                    <span class="headline font-weight-regular">Edit Profile</span>
                    <span class="body-2 font-weight-thin">Complete Your Profile</span>
                  </div>

                  <!-- Icon -->
                  <div>
                    <v-icon class="font-weight-thin" x-large>mdi-account-settings-outline</v-icon>
                  </div>
                </v-row>
              </v-card-title>
            </v-card>
          </v-card-text>

          <!-- Form -->
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-col col="12">
                <v-row justify="start">
                  <v-flex class="mx-3">
                    <v-text-field
                      v-model="firstName"
                      :rules="nameRules"
                      label="First Name"
                      required
                      placeholder="Abebe"
                      outlined
                      color="black"
                    ></v-text-field>
                  </v-flex>

                  <v-flex class="mx-3">
                    <v-text-field
                      v-model="lastName"
                      :rules="nameRules"
                      label="Last Name"
                      required
                      placeholder="Kebede"
                      outlined
                      color="black"
                    ></v-text-field>
                  </v-flex>
                </v-row>
                <!--  -->
                <v-row justify="start">
                  <v-col cols="7">
                    <v-flex>
                      <v-select
                        v-model="proffession"
                        :items="professions"
                        label="Profession"
                        outlined
                        color="black"
                        :rules="[v => !!v || 'Gender is required']"
                      ></v-select>
                    </v-flex>
                  </v-col>
                  <v-col cols="5">
                    <v-flex>
                      <v-select
                        v-model="gender"
                        :items="genders"
                        label="Gender"
                        outlined
                        color="black"
                        :rules="[v => !!v || 'Gender is required']"
                      ></v-select>
                    </v-flex>
                  </v-col>
                </v-row>
                <!--  -->
                <v-flex>
                  <v-text-field
                    v-model="userName"
                    :rules="nameRules"
                    label="User Name"
                    required
                    placeholder="abekebe"
                    outlined
                    color="black"
                  ></v-text-field>
                </v-flex>

                <v-flex>
                  <v-text-field
                    v-model="password"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[value => !!value || 'Required.', v => v.length >= 8 || 'Min 8 characters']"
                    :type="show1 ? 'text' : 'password'"
                    name="input-10-1"
                    label="Password"
                    hint="At least 8 characters"
                    counter
                    @click:append="show1 = !show1"
                    required
                    outlined
                    color="black"
                  ></v-text-field>
                </v-flex>

                <v-row wrap justify="end">
                  <v-btn
                    :disabled="!valid"
                    class="mt-3 mr-3"
                    color="teal lighten-2"
                    @click="updateUserProfile"
                  >Update Profile</v-btn>
                </v-row>
              </v-col>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex md4 sm10 xs10 class="mt-4">
        <v-container grid-list-xs text-xs-center fill-height>
          <v-row justify="space-around" class="mt-5">
            <v-card style="border-radius: 13px;" width="90%" class="elevation-15 ma-3">
              <v-card-text>
                <v-row justify="center">
                  <v-hover>
                    <v-avatar
                      class="elevation-20"
                      size="140"
                      color="grey lighten-4"
                      style="margin-top: -80px;position: relative"
                    >
                      <img :src="profileUrl" />
                    </v-avatar>
                  </v-hover>
                </v-row>
              </v-card-text>

              <v-card-text>
                <v-row wrap justify="center">
                  <span
                    class="title black--text"
                    style="font-weight: 500;"
                    v-show="user.firstName"
                  >{{ user.firstName + " " + user.lastName}}</span>
                </v-row>
                <v-row justify="center" align="center" class="mb-2">
                  <span class="caption blue--text">@{{ user.username}}</span>
                </v-row>
                <v-divider></v-divider>

                <v-container>
                  <v-row justify="space-between" class="mt-2">
                    <span class="body-2">First Name</span>
                    <span class="body-2 font-weight-bold">{{ user.firstName }}</span>
                  </v-row>
                  <v-row justify="space-between" class="mt-2">
                    <span class="body-2">Last Name</span>
                    <span class="body-2 font-weight-bold">{{ user.lastName }}</span>
                  </v-row>
                  <v-row justify="space-between" class="mt-2">
                    <span class="body-2">Username</span>
                    <span class="body-2 font-weight-bold">{{ user.username }}</span>
                  </v-row>
                  <v-row justify="space-between" class="mt-2">
                    <span class="body-2">Profession</span>
                    <span class="body-2 font-weight-bold">{{ user.proffession }}</span>
                  </v-row>
                  <v-row justify="space-between" class="mt-2">
                    <span class="body-2">Gender</span>
                    <span class="body-2 font-weight-bold">{{ user.sex }}</span>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-row>
        </v-container>
      </v-flex>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { baseUrl } from "@/services/constants.js";

export default {
  data() {
    return {
      //
      url: this.$imgUrl,
      nameRules: [
        v => !!v || "Name is required",
        v => (v && v.length <= 10) || "Name must be less than 10 characters"
      ],
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ],
      show1: false,
      valid: false,
      // firstName: this.user.firstname,
      // lastName: this.user.lastName,
      // userName: this.user.username,
      password: "",
      // proffession: this.user.proffession || null,
      // gender: this.user.sex,
      errors: [],
      genders: ["Male", "Female"],
      professions: ["Software Engineer", "Student", "Developer"]
    };
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    }
  },
  computed: {
    ...mapState("auth", ["user"]),
    profileUrl() {
      if (this.user.sex == "Male") {
        if (this.user.proffession == "Software Engineer") {
          return require("@/assets/images/SE/m.jpg");
        } else if (this.user.proffession == "Developer") {
          return require("@/assets/images/DV/m.png");
        } else return require("@/assets/images/ST/m.png");
      } else {
        if (this.user.proffession == "Software Engineer") {
          return require("@/assets/images/SE/f.jpg");
        } else if (this.user.proffession == "Developer") {
          return require("@/assets/images/DV/f.png");
        } else return require("@/assets/images/ST/f.png");
      }
    },
    firstName() {
      return this.user.firstName;
    },
    lastName() {
      return this.user.lastName;
    },
    userName() {
      return this.user.username;
    },
    proffession() {
      return this.user.proffession || null;
    },
    gender() {
      return this.user.sex;
    }
  },
  methods: {
    ...mapActions("auth", ["updateProfile", "updatePP"]),
    save(date) {
      this.$refs.menu.save(date);
    },
    updateUserProfile() {
      var data = {
        // id: this.user.id,
        firstName: this.firstName,
        lastName: this.lastName,
        username: this.userName,
        password: this.password,
        proffession: this.proffession,
        sex: this.gender
      };
      this.updateProfile(data);
    },
    onFileSelected(event) {
      var pp = event.target.files[0];
      var imgFD = new FormData();
      imgFD.append("image", pp);
      this.updatePP(imgFD);
    },
    updateProfilePicture() {
      //
      this.$refs.image.click();
    },
    getDetail() {
      print("Getting Detail...");
    }
  },
};
</script>
